import BaseService from './BaseService';

export interface AutocompleteProps {
  id: string;
  street: string;
  address: string;
  city: string;
  location: {
    lat: string;
    lng: string;
  }
  state: string;
  zipCode: string;
  neighborhood: string;
  secondary_text: string;
}

export interface SearchProps {
  zip_code?: string;
  number?: string;
  lat?: number;
  lng?: number;
  order_type?: string;
}

export interface AddressByLatLngProps {
  zip_code?: string;
  number?: string;
  lat?: number;
  lng?: number;
  street?: string;
  complement?: string;
  city?: string;
  neighborhood?: string;
  zipcode?: string;
  state?: string;
  search?: string;
}

export default class AddressService {
  baseService: BaseService;
  ApiBaseService: BaseService;
  constructor(orderType: string) {
    this.baseService = new BaseService(orderType);
    this.ApiBaseService = new BaseService('');
  }

  async autocomplete (text: string): Promise<AutocompleteProps[]> {
    try {
      const response = await this.ApiBaseService.http.get(`address/autocomplete?text=${text}`);
      return response.data;
    } catch (error) {
      console.error('Erro autocomplete:', error);
      throw error;
    }
  }
  
  async autocompleteGoogle (text: string): Promise<AutocompleteProps[]> {
    try {
      const response = await this.ApiBaseService.http.get(`address/autocomplete-google?text=${text}`);
      return response.data;
    } catch (error) {
      console.error('Erro autocompleteGoogle:', error);
      throw error;
    }
  }

  async search (params: SearchProps): Promise<SearchProps[]> {
    try {
      const query = new URLSearchParams({
        ...(params.zip_code && { zip_code: params.zip_code }),
        number: params.number && params.number !== "s/n" ? params.number : "0",
        ...(params.lat && { lat: String(params.lat) }),
        ...(params.lng && { lng: String(params.lng) }),
        ...(params.order_type && { order_type: params.order_type }),
      });

      const queryString = query.toString();
      const response = await this.ApiBaseService.http.get(`stores/search?${queryString}`);
      return response.data;
    } catch (error) {
      console.error('Erro search:', error);
      throw error;
    }
  }

  async components (text: string): Promise<SearchProps[]> {
    try {
      const response = await this.ApiBaseService.http.get(`address/components?text=${text}`);
      return response.data;
    } catch (error) {
      console.error('Erro latLng:', error);
      throw error;
    }
  }

  async addressByLatLng (text: string): Promise<AddressByLatLngProps> {
    try {
      const response = await this.ApiBaseService.http.get(`address/address-details?query_param=${text}`);
      return response.data;
    } catch (error) {
      console.error('Erro addressBylatLng:', error);
      throw error;
    }
  }
  
  async create (payload: any): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.post("/customers/addresses/create", payload);
      return response.data;
    } catch (error) {
      console.error('Erro create:', error);
      throw error;
    }
  }


}